import { readPageViewPreference, writePageViewPreference } from './pageViewPreferences';

const FAVORITES_KEY = 'sidebar:favorites';
const SIDEBAR_KEY = 'sidebar';

export function readFavoritePages() {
  const saved = readPageViewPreference(FAVORITES_KEY);
  return Array.isArray(saved.pages) ? saved.pages.filter((page) => page?.path && page?.label) : [];
}

export function writeFavoritePages(pages) {
  writePageViewPreference(FAVORITES_KEY, { pages });
}

export function readSidebarOpenPreference() {
  const saved = readPageViewPreference(SIDEBAR_KEY);
  return typeof saved.open === 'boolean' ? saved.open : null;
}

export function writeSidebarOpenPreference(open) {
  if (!window.matchMedia('(min-width: 1025px)').matches) return;
  writePageViewPreference(SIDEBAR_KEY, { open: Boolean(open) });
}
